
<div>
    <b-tabs v-model="tabIndex" content-class="subTab">
        <b-tab title="Välj/visa" class="mt2">
            <b-row>
                <b-col cols="3">
                    <h3 class="mt-2">
                        Valda manuskript
                        <b-button
                            variant="danger"
                            class="float-right mt-0"
                            @click="deselectAllManuscripts"
                            >Avmarkera alla</b-button
                        >
                    </h3>
                    <hr />
                    <div>
                        <b-form autocomplete="off">
                            <b-list-group
                                style="margin-bottom: 10px; max-height: calc(100vh - (42px*4); overflow-y: auto"
                            >
                                <b-list-group-item
                                    v-for="(
                                        s, index
                                    ) in selectedManuscripts"
                                    v-bind:key="index"
                                >
                                    <b-row>
                                        <b-col
                                            cols="7"
                                            class="align-self-center"
                                        >
                                            {{ s.title }}
                                        </b-col>
                                        <b-col class="align-self-center">
                                            <b-input-group>
                                                <b-input
                                                    placeholder="Förkortning"
                                                    v-model="s.abb"
                                                    :formatter="
                                                        abbFormatter
                                                    "
                                                    @focus="
                                                        setCurrentAbb(
                                                            index,
                                                            s.abb
                                                        )
                                                    "
                                                    @blur="
                                                        setManuscriptAbb(
                                                            index,
                                                            s.abb
                                                        )
                                                    "
                                                ></b-input>
                                                <b-input-group-append>
                                                    <b-button
                                                        style="margin: 0px"
                                                        variant="danger"
                                                        @click="
                                                            deselectManuscript(
                                                                index,
                                                                ''
                                                            )
                                                        "
                                                        >x</b-button
                                                    >
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                    </b-row>
                                </b-list-group-item>
                            </b-list-group>
                        </b-form>
                    </div>
                </b-col>
                <b-col cols="9">
                    <div>
                        <b-list-group
                            scrollable
                            style="
                                max-height: calc(100vh - (50px * 3));
                                overflow-y: auto;
                            "
                        >
                            <b-list-group-item
                                v-for="m in manuscripts"
                                v-bind:key="m.id"
                            >
                                <b-row>
                                    <b-col>
                                        <h4>{{ m.title }}</h4>
                                    </b-col>
                                    <b-col>
                                        <b-form-group class="float-right">
                                            <b-button
                                                class="float-right"
                                                variant="primary"
                                                @click="selectManuscript(m)"
                                                >Välj</b-button
                                            >
                                            <b-button
                                                class="float-right"
                                                variant="warning"
                                                @click="editManuscript(m)"
                                                >Redigera</b-button
                                            >
                                            <b-button
                                                class="float-right"
                                                variant="danger"
                                                @click="
                                                    openConfirmRemoveModal(
                                                        m
                                                    )
                                                "
                                                >Ta bort</b-button
                                            >
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <!--<div class="preview">
                <span class="preview" v-html="m.content"></span>
              </div>-->
                            </b-list-group-item>
                        </b-list-group>
                    </div>
                </b-col>
                <b-col cols="2">
                    <b-list-group></b-list-group>
                </b-col>
            </b-row>
            <b-modal
                ref="confirmRemoveModal"
                size="lg"
                hide-footer
                hide-backdrop
                @hide="closeConfirmRemoveModal"
                title="Bekräfta ta bort"
            >
                <h4>{{ selectedForRemoval.title }}</h4>
                <hr />

                <div class="preview" style="height: 45vh !important">
                    <span
                        class="preview"
                        v-html="selectedForRemoval.preview"
                    ></span>
                </div>
                <hr />
                <b-button
                    class="float-right"
                    variant="secondary"
                    @click="closeConfirmRemoveModal()"
                    >Avbryt</b-button
                >

                <b-button
                    class="float-right"
                    variant="danger"
                    @click="removeManuscript()"
                    >Ta bort</b-button
                >
            </b-modal>
            <b-modal
                ref="confirmCreateNewModal"
                hide-footer
                hide-header
                hide-backdrop
                @hide="closeConfirmCreateNewModal()"
            >
                <p>
                    Vill du spara manuset du redigerar innan du skapar ett
                    nytt?
                </p>

                <b-button
                    class="float-right"
                    variant="primary"
                    @click="saveAndCreateNew()"
                    >Spara och skapa nytt</b-button
                >
                <b-button
                    class="float-right"
                    variant="danger"
                    @click="createNewWithoutSaving()"
                    >Skapa nytt</b-button
                >
            </b-modal>
            <b-modal
                ref="stopEditingModal"
                hide-footer
                hide-header
                hide-backdrop
                @hide="closeStopEditingModal()"
            >
                <p>Vill du spara manuset du redigerar innan du stänger?</p>
                <b-button
                    class="float-right"
                    variant="primary"
                    @click="saveAndClose()"
                    >Spara</b-button
                >
                <b-button
                    class="float-right"
                    variant="danger"
                    @click="dontSaveAndClose()"
                    >Stäng utan att spara</b-button
                >
            </b-modal>
        </b-tab>
        <b-tab
            :title="createAction.text"
            :title-link-class="createAction.class"
            class="manuscriptTab"
        >
            <div class="manuscriptEditor">
                <ManuscriptEditor v-bind:id="id" />
            </div>
            <br />
            <b-button @click="saveManuscript">Spara</b-button>
        </b-tab>
        <template
            v-if="id && id !== 'parsed' && id !== 'new'"
            v-slot:tabs-end
        >
            <b-nav-item
                @mouseover="hoverClose(true)"
                @mouseout="hoverClose(false)"
                v-bind:style="editAction.class"
                role="presentation"
                @click="openStopEditingModal()"
            >
                <span :style="editAction.class">
                    {{ editAction.text }}
                </span>
            </b-nav-item>
            <b-nav-item
                href="#"
                role="presentation"
                @click="openConfirmCreateNewModal()"
                >Skapa nytt</b-nav-item
            >
        </template>
    </b-tabs>
    <SaveManuscript
      v-bind:manuscript="manuscript"
      v-bind:id="id"
      v-bind:close="close"
    />
</div>
